import { color } from 'config/color'

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker as MUIDatePicker } from '@mui/x-date-pickers/DatePicker'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'

import { Box } from '@mui/material'
import dayjs, { type Dayjs } from 'dayjs'
import { FormLabel } from '../Label'

interface DatePickerProps {
  value: string
  onChange: any
  label: string
  shouldDisableDate: (date: Dayjs) => boolean
}

export const DatePicker: React.FC<DatePickerProps> = (
  props: DatePickerProps
) => {
  return (
    <Box display="flex" flexDirection="column" alignItems="flex-start" gap={1}>
      <FormLabel>{props.label}</FormLabel>

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <MUIDatePicker
          format="YYYY-MM-DD"
          defaultValue={dayjs(props.value)}
          value={dayjs(props.value)}
          onChange={props.onChange}
          orientation="portrait"
          sx={{
            svg: { color: color.primary[600] },
            width: '100%'
          }}
          slots={{
            openPickerIcon: KeyboardArrowDownIcon
          }}
          shouldDisableDate={(date) => props.shouldDisableDate(date)}
        />
      </LocalizationProvider>
    </Box>
  )
}
